import React, { Component } from 'react'
import { func, object } from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { PagesPaths } from '../../constants/Pages'
import { SubHero } from '../../components/header/SubHero'
import { addNoIndexIfNotExists, removeNoIndexIfExists } from '../../utilities/window'

/**
 * What the backend can tell this page, mirroring its `PaymentPageState` enum. Anything else is shown
 * as UNKNOWN rather than raw, so a state added on the server without a message here degrades into a
 * sentence rather than an empty screen.
 */
export const PaymentStatuses = {
  SUCCESS: 'success',
  FAILED: 'failed',
  PAID: 'paid',
  EXPIRED: 'expired',
  UNKNOWN: 'unknown'
}

/** The two outcomes that deserve the reassuring image rather than a bare sentence. */
const SETTLED = [PaymentStatuses.SUCCESS, PaymentStatuses.PAID]

/**
 * Where a customer lands after paying by card, or when the link they opened has nothing left to
 * collect.
 *
 * Until now the backend sent them to the site root in both cases, which shows the sign-up screen to
 * anyone not logged in: someone who had just paid was asked to create an account, with no word about
 * their payment. This page says what happened instead, and only then offers the account.
 */
class PaymentStatusComponent extends Component {
  componentDidMount () {
    // Never content for a search engine: reached only from a one-off link in an e-mail or an SMS,
    // and it says nothing that would make sense out of that context.
    addNoIndexIfNotExists()
  }

  componentWillUnmount () {
    // The tag lives in the document head, not in this component: leaving it behind would follow the
    // visitor onto every page of the session — and this site earns its traffic from the city pages.
    removeNoIndexIfExists()
  }

  status () {
    const value = new URLSearchParams(window.location.search).get('etat')
    return Object.keys(PaymentStatuses)
      .map((key) => PaymentStatuses[key])
      .indexOf(value) >= 0
      ? value
      : PaymentStatuses.UNKNOWN
  }

  render () {
    const { t, history } = this.props
    const status = this.status()
    const breadcrumbs = [{ name: t('common:payment_status:breadcrumb'), path: '' }]

    return (
      <div>
        <SubHero breadcrumb={breadcrumbs} />
        <div className='layout__container'>
          {SETTLED.indexOf(status) >= 0 && (
            <img
              className='img--centered img--rounded'
              src='/app/images/checked_image.png'
              alt={t(`common:payment_status:${status}_title`)}
            />
          )}
          <h1 className='paragraph--centered' style={{ marginTop: '20px' }}>
            {t(`common:payment_status:${status}_title`)}
          </h1>
          <p className='paragraph--centered'>
            {t(`common:payment_status:${status}_message`)}
          </p>
          {/* Pas de compte à proposer à qui vient d'échouer : ce client doit réessayer avec son
              lien, ce que le message lui dit. L'envoyer vers l'écran de connexion serait remettre
              exactement l'obstacle que cette page existe pour retirer — et le client d'une facture
              express n'a de toute façon aucun compte. */}
          {status !== PaymentStatuses.FAILED && (
            <p className='paragraph--centered'>
              <a
                style={{ cursor: 'pointer' }}
                onClick={() => history.push(PagesPaths.SIGNIN.path)}
              >
                {t('common:payment_status:signin')}
              </a>
            </p>
          )}
          <p className='paragraph--centered'>
            <a
              style={{ cursor: 'pointer' }}
              onClick={() => history.push('/')}
            >
              {t('common:payment_status:home')}
            </a>
          </p>
        </div>
      </div>
    )
  }
}

PaymentStatusComponent.propTypes = {
  t: func,
  history: object
}

export const PaymentStatusPage = withRouter(translate()(PaymentStatusComponent))



// WEBPACK FOOTER //
// ./src/pages/paiement/PaymentStatusPage.js